import { render, staticRenderFns } from "./BusListPage.vue?vue&type=template&id=f2deec0c&scoped=true"
import script from "./BusListPage.vue?vue&type=script&lang=js"
export * from "./BusListPage.vue?vue&type=script&lang=js"
import style0 from "./BusListPage.vue?vue&type=style&index=0&id=f2deec0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2deec0c",
  null
  
)

export default component.exports